import React, { useEffect, useState } from "react";

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="px-[4.5rem] bg-[#DC143C]">
        <h2 className="text-white text-center font-[Figtree] text-[2.875rem] font-medium leading-[3.6875rem] tracking-[-0.115rem] pt-16 pb-5">
          Frequently Asked Questions
        </h2>
        <div className="px-[22rem] pb-[3.19rem]">
          <div className="relative">
            <input
              type="text"
              placeholder="What are you looking for?"
              className="w-full py-3 px-[1.06rem] pr-[4rem] rounded-[0.3125rem]"
            />
            <button className="absolute right-[1rem] top-1/2 transform -translate-y-1/2 text-[#E11740] font-[Figtree] text-[0.75rem] font-normal leading-[1.25rem]">
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="bg-[#CC1136] px-[8.12rem] py-12">
        <h2 className="text-white text-center font-[Figtree] text-[1.875rem] font-bold leading-[1.5rem] mb-[2.88rem]">
          Topics
        </h2>
        <div className="flex gap-[2.25rem] flex-wrap justify-center">
          <div className="flex gap-[0.62rem] py-[0.375rem] px-[1.8125rem] border border-[#EF8298] hover:bg-[#E02D3D] rounded-[0.375rem] cursor-pointer">
            <img src="/assets/AccountIcon.svg" />
            <h2 className="text-white font-[Figtree] text-[1rem] font-medium leading-[2.6875rem]">
              Account
            </h2>
          </div>
          <div className="flex gap-[0.62rem] py-[0.375rem] px-[1.8125rem] border border-[#EF8298] hover:bg-[#E02D3D] rounded-[0.375rem] cursor-pointer">
            <img src="/assets/MobileIcon.svg" />
            <h2 className="text-white font-[Figtree] text-[1rem] font-medium leading-[2.6875rem]">
              Mobile App
            </h2>
          </div>
          <div className="flex gap-[0.62rem] py-[0.375rem] px-[1.8125rem] border border-[#EF8298] hover:bg-[#E02D3D] rounded-[0.375rem] cursor-pointer">
            <img src="/assets/forexFaqIcon.svg" />
            <h2 className="text-white font-[Figtree] text-[1rem] font-medium leading-[2.6875rem]">
              Forex Card
            </h2>
          </div>
          <div className="flex gap-[0.62rem] py-[0.375rem] px-[1.8125rem] border border-[#EF8298] hover:bg-[#E02D3D] rounded-[0.375rem] cursor-pointer">
            <img src="/assets/RemmitenceFaqIcon.svg" />
            <h2 className="text-white font-[Figtree] text-[1rem] font-medium leading-[2.6875rem]">
              Remmitance
            </h2>
          </div>
          <div className="flex gap-[0.62rem] py-[0.375rem] px-[1.8125rem] border border-[#EF8298] hover:bg-[#E02D3D] rounded-[0.375rem] cursor-pointer">
            <img src="/assets/CorporateCardIcon.svg" />
            <h2 className="text-white font-[Figtree] text-[1rem] font-medium leading-[2.6875rem]">
              Corporate Cards
            </h2>
          </div>
        </div>
      </div>

      <div className="px-[4.5rem] mt-24">
        {/* Collapsible FAQ Items */}
        {[
          {
            question: "How do I apply for a Nimo Forex Card?",
            answer:
              "You can apply for a Nimo Forex Card through our mobile app or website. Simply sign up, load funds, and get started. Virtual cards are available instantly, and physical cards can be delivered to your doorstep.",
          },
          {
            question: "What currencies can I load on the card?",
            answer:
              "Nimo Forex Cards support all major international currencies, including USD, EUR, GBP, AUD, CAD, SGD, AED, and many more. Check the app for the full list.",
          },
          {
            question: "Can I lock in exchange rates while loading my card?",
            answer:
              "Yes! With Nimo Forex Cards, you can lock in real-time exchange rates while loading funds, protecting you from currency fluctuations.",
          },
          {
            question: "Where can I use my Nimo Forex Card?",
            answer:
              "You can use your card anywhere in the world where Visa/Mastercard is accepted, including ATMs, retail stores, and online platforms.",
          },
          {
            question: "Can I withdraw cash from ATMs with my Forex Card?",
            answer:
              "Yes! You can withdraw local currency from ATMs worldwide. Many ATMs are fee-free when you use your Nimo Forex Card.",
          },
          {
            question: "How can I contact support for assistance?",
            answer:
              "You can reach our customer support team 24/7 through the Nimo app, email, or hotline for any questions or issues.",
          },
        ].map((faq, index) => (
          <div
            key={index}
            className="border p-6 rounded-lg border-[#DEDEDE] text-left mt-[1.12rem] cursor-pointer"
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex justify-between items-center">
              <h3
                className={`text-[1.25rem] leading-normal text-[#1D1D1D] font-[Figtree] tracking-tight 
                                ${
                                  openIndex === index
                                    ? "font-bold"
                                    : "font-medium"
                                }`}
              >
                {faq.question}
              </h3>
              <span className="text-xl font-bold">
                {openIndex === index ? (
                  <img src="/assets/UpArrow.png" alt="Collapse" className="" />
                ) : (
                  <img src="/assets/DownArrow.png" alt="Expand" className="" />
                )}
              </span>
            </div>
            {openIndex === index && (
              <p className="text-[#2F2A35] text-[0.875rem] font-normal mt-2 leading-[1.6875rem]">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
